import React from "react";
import { AppRoutes } from "../../routes/AppRouter";
import Page from "../components/container/Page";
import ProductDialog from "../components/products/ProductDialog";
import ProductsList from "../components/products/ProductsList";
import SearchBox from "../components/search/SearchBox";
import { useProducts } from "../../state/api/products/useProducts";
import AccessLevelPill from "../components/products/AccessLevelPill";
import { QUERY_KEY } from "../../types/query.types";

export default function ProductsPage() {

  const { products, isRefetching } = useProducts();

  return (
    <Page
      title={AppRoutes.Products.Label}
      subtitle={AppRoutes.Products.Subtitle}
      actions={[
        <AccessLevelPill key="access-level" />,
        <ProductDialog key="product-dialog" />
      ]}
    >
      {!!products?.length && (
        <SearchBox loading={isRefetching} param={QUERY_KEY.PRODUCT_Q}  />
      )}
      <ProductsList />
    </Page>
  )
}